// extracted by mini-css-extract-plugin
export default {"metricCardBox":"CMetricCard_metricCardBox__fE+F-","time":"CMetricCard_time__PKRlk"};